<template>
  <div class="chooseType">
    <div class="listContainer" v-for="(item, index) in typeList" :key="index" :class="item.type == type ? 'active' : ''"
      @click="articleUploadDETOne(item.uplinkType, item.type)">
      <div class="left_">
        <img src="@/assets/images/radioIconActive.png" v-if="item.type == type" />
        <img src="@/assets/images/radioIcon.png" v-else />
      </div>

      <div class="right_">
        <div>{{ item.name }}</div>
        <div>{{ item.introduce }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { ElMessage } from "element-plus";
import { articleUploadDETOne, getUserInfo } from "../../api/interfaceList.js";
export default {
  name: "chooseType",
  data() {
    return {
      getUserInfoData: '',
      userInformation: JSON.parse(Cookies.get("userInformation")),
      type: 1,
      typeList: [
        {
          name: "龙源版权确权证书",
          introduce: "适合垂直领域专家，意见领袖、专业人士申请",
          type: 1,
          uplinkType: 1
        },
        {
          name: "龙源版权确权证书+北京版权证书",
          introduce: "适合刊社、企业或其他以生产内容为主的组织和团体申请",
          type: 2,
          uplinkType: 3,
        },
      ],
    };
  },
  mounted() {
    this.getUserInfo()
  },
  methods: {
    getUserInfo() {
      getUserInfo({
        usercode: this.userInformation.userCode
      }).then(res => {
        if (res.data.isEnterpriseAuthentication == 2 && res.data.isPersonalAuthentication == 2) {
          ElMessage({
            message: '请完成认证',
            type: "success",
          });
          this.$router.go(-1)
        }
        this.getUserInfoData = res.data
      })
    },
    articleUploadDETOne(uplinkType, e) {
      if (e == 1) {
        articleUploadDETOne({
          postcode: this.getUserInfoData.isEnterpriseAuthentication == 1 ? 100 : 1,
          userCode: JSON.parse(Cookies.get("userInformation")).userCode,
          uplinkType: uplinkType
        }).then((res) => {
          ElMessage({
            message: res.message,
            type: "success",
          });
          if (res.code == 1) {
            let json = {
              key: 1,
              isOk: true
            };
            Cookies.set("uniqueCode", res.data.uniqueCode)
            this.$emit("isOk", json);
            this.type = e;
            this.$emit("chooseType", e);
          }
        });
      } else {
        ElMessage({
            message: "暂未开发",
          });
      }

    },
  },
  components: {},
};
</script>
<style lang="scss" scope>
.chooseType {
  width: 480px;

  .active {
    border: 1px solid #008aea !important;
    background: #fff !important;
  }

  .listContainer {
    width: 100%;
    height: 80px;
    background: #f5f7fa;
    border-radius: 8px;
    padding: 16px 24px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 20px;
    cursor: pointer;

    .right_ {
      width: 404px;

      div:nth-of-type(1) {
        font-size: 18px;
        font-family: AlibabaPuHuiTiM;
        color: #008aea;
      }

      div:nth-of-type(2) {
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #909399;
        margin-top: 4px;
      }
    }

    .left_ {
      width: 24px;

      img {
        width: 100%;
      }
    }
  }
}
</style>
